import { NavLink } from 'react-router-dom';
import { Home, MessageCircle, Shield, FileText } from 'lucide-react';

const WHATSAPP_SUPPORT = "573206313258";

const navItems = [
  { to: '/', icon: Home, label: 'Inicio' },
  { to: '/transparencia', icon: Shield, label: 'Info' },
  { type: 'whatsapp', icon: MessageCircle, label: 'WhatsApp' },
  { to: '/terms', icon: FileText, label: 'Términos' },
];

export function BottomNav() {
  const openWhatsApp = () => {
    const message = encodeURIComponent(
      `Hola TuPrima 👋\n\nSolicito información sobre la devolución de mi compra.`
    );
    window.open(`https://wa.me/${WHATSAPP_SUPPORT}?text=${message}`, '_blank');
  };

  return (
    <nav className="bottom-nav" data-testid="bottom-nav">
      <div className="max-w-md mx-auto flex items-center justify-around">
        {navItems.map((item, index) => {
          const Icon = item.icon;
          
          if (item.type === 'whatsapp') {
            return (
              <button
                key={index}
                onClick={openWhatsApp}
                className="bottom-nav-item min-touch-target flex flex-col items-center text-emerald-600"
                data-testid="nav-whatsapp"
              >
                <Icon className="w-6 h-6 mb-1" />
                <span className="text-xs font-medium">{item.label}</span>
              </button>
            );
          }
          
          return (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `bottom-nav-item min-touch-target ${isActive ? 'active' : ''}`
              }
              data-testid={`nav-${item.label.toLowerCase().replace(' ', '-')}`}
            >
              <Icon className="w-6 h-6 mb-1" />
              <span className="text-xs font-medium">{item.label}</span>
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
